// index.tsx
// Route configuration for the Cerner EHR experience.
// Sets up navigation and route logic for Cerner-specific flows.

import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import { NavItem } from "@/types/navigation";
import { styled } from "@stitches/react";

const RoutesWrapper = styled("div", {});

/**
 * Route definitions for Cerner navigation.
 */
const routes: NavItem[] = [
  {
    id: "my-tasks",
    text: "My Tasks",
    href: "/my-tasks",
    element: <p>My Tasks</p>,
  },
];

/**
 * Wrapper for Cerner app layout, including outlet.
 */
const CernerAppWrapper = () => {
  return (
    <div data-testid="cerner-app-wrapper">
      <Outlet />
    </div>
  );
};

/**
 * CernerRoutes Component
 * Sets up Cerner-specific routes and navigation.
 */
const CernerRoutes = () => {
  /**
   * Creates the Cerner route structure.
   */
  const createRoutes = () => {
    const getBasename = () => {
      return "/";
    };

    const basename = getBasename();

    return createBrowserRouter(
      [
        {
          path: "/",
          id: "root",
          element: <CernerAppWrapper />,
          children: routes.map((route) => {
            return {
              path: route.href,
              element: route.element,
            };
          }),
        },
      ],
      { basename },
    );
  };

  return (
    <RoutesWrapper>
      <RouterProvider router={createRoutes()} />
    </RoutesWrapper>
  );
};

export default CernerRoutes;
